(ns admin.containers.curriculum.learner-pre-registration
  (:require [re-frame.core :as re-frame]
            [applied-science.js-interop :as j]
            [reagent-form.core :as rf]
            [reagent-form.validators :as v]
            [reagent-form.transformers :as t]
            [clojure.string :as str]
            [inflections.core :as inflections]
            [cemerick.url :refer [map->query]]
            [potpuri.core :as pot]
            [admin.events.containers.curriculum-learner-pre-registration :as <curriculum-learners]
            [admin.events.curriculum-pre-registration :as >curriculum-pre-reg]
            [admin.router.utils :as aru]
            [admin.constants :as c]
            [kyber.utils :as ku]
            [kyber.components.composite.pagination-controls :as pagination-controls]
            [kyber.components.composite.loading :as loading]
            [kyber.components.base.text :as text]
            [kyber.components.form-fields.select :as select]
            [kyber.components.base.button :as button]
            [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:container
    {:margin    [(gs [:spacing :p20]) :auto]
     :padding   [(gs [:spacing :p2])
                 (gs [:spacing :p20])]
     :display :grid
     :max-width (str c/page-max-width "px")}

    :main-header
    {:display         :flex
     :width           "100%"
     :justify-content :space-between
     :margin-bottom   (gs [:spacing :p20])
     (gs [:queries :mobile-landscape])
     {:display :block}}

    :add-or-export-container
    {:display         :flex
     :width           "50%"
     :justify-content :flex-end
     :margin-top (gs [:spacing :p16])
     (gs [:queries :mobile-landscape])
     {:display :block}}

    :form-container
    {:display :flex
     :flex-direction :column
     :padding (gs [:spacing :p20])
     :width (str "calc(50vw - " (gs [:spacing :p12]) ")")
     :background-color (gs [:colors :true-white])}

    :search-container
    {:display :flex
     :justify-content :flex-end
     :align-items :flex-end
     :padding-bottom (gs [:spacing :p32])}

    :search-submit-container
    {:margin [0 0 (gs [:spacing :p8]) (gs [:spacing :p12])]}

    :close-container
    {:width "100%"
     :display :flex
     :justify-content :flex-end}

    :cta-container
    {:display :flex
     :align-items :flex-end
     :justify-content :space-between}

    :delete-cta-container
    {:margin-top (gs [:spacing :p12])
     :margin-bottom (gs [:spacing :p8])
     :display :flex
     :justify-content :center}

    :no-top-margin
    {:margin-top (gs [:spacing :p0])
     :margin-bottom (gs [:spacing :p12])}

    :no-top-padding
    {:padding-top (gs [:spacing :p0])}

    :search-label
    {:margin-top (gs [:spacing :p16])}

    :admin-content-container
    {:display :flex
     :justify-content :space-between
     :align-items :center
     :padding (gs [:spacing :p8])
     :border-radius (gs [:radius :r7])
     :border (str "1px solid " (gs [:colors :error-500]))
     :background-color "rgba(255,0,0,0.1)"
     :margin-top (gs [:spacing :p8])
     :margin-bottom (gs [:spacing :p12])}

    :table-container
    {:width "100%"
     :margin-bottom (gs [:spacing :p40])
     "& td, th"
     {:padding [(gs [:spacing :p4])
                (gs [:spacing :p12])]}}

    :table-head
    {:text-align :center

     "& th > *"
     {:margin (gs [:spacing :p0])}}

    :table-body
    {:text-align :center
     :border (str "1px solid " (gs [:colors :gray-scale-200]))

     "& td"
     {:vertical-align :middle
      :background-color (gs [:colors :true-white])}}}))

(defn render-create-or-update-learner 
  [{:keys [event-key dismiss-fn]}]
  (let [is-submitting
        (re-frame/subscribe [:request/is-dispatching event-key])]
    (fn [{:keys [curriculum-uuid valid-tags learner event-key]}]
      (let [{email-address :user/email-address
             user-uuid :user/uuid
             :user/keys [given-name
                         family-name]
             :curriculum/keys [registration]}
            learner

            is-new
            (nil? user-uuid)

            valid-tag? (fn [tag-uuid tag-group-values]
                         (some #(= tag-uuid
                                   (:content-provider.tag/uuid %))
                               tag-group-values))]
        [:div {:class (:form-container classes)}
         [:div {:class (:close-container classes)}
          [button/icon-button
           {:on-click dismiss-fn
            :style {:margin-left (gs [:spacing :p4])}}
           :close]]
         [rf/form {:id event-key
                   :is-submitting is-submitting}
          [:form
           {:rf/form
            {:on-submit
             (fn [payload]
               (let [tag-group-field-keys
                     (mapv #(->> %
                                 :content-provider.tag-group/uuid
                                 (str "tag-group-")
                                 keyword)
                           valid-tags)

                     tag-group-values
                     (-> payload
                         (select-keys tag-group-field-keys)
                         vals
                         vec)]
                 (re-frame/dispatch
                  [event-key
                   (cond-> (as-> payload p
                             (assoc p
                                    :curriculum/uuid curriculum-uuid
                                    :curriculum.registration/tags tag-group-values)
                             (apply dissoc p tag-group-field-keys))
                     (some? user-uuid)
                     (assoc :user/uuid user-uuid))
                   {:response-keys [:curriculum/uuid
                                    :user/uuid
                                    :user/email-address
                                    :user/family-name
                                    :user/given-name
                                    :curriculum-registration/created-at
                                    {:curriculum/registration
                                     [:content-provider.tag-group/uuid
                                      :content-provider.tag-group/name
                                      :content-provider.tag/uuid
                                      :content-provider.tag/name]}]
                    :on-success dismiss-fn
                    :on-success-toast (if is-new
                                        "Learner registered."
                                        "Learner registration updated.")
                    :on-failure-toast (if is-new
                                        "Something went wrong registering this learner."
                                        "Something went wrong updating this learner's registration.")}])))}}
           [:div
            (rf/input
             (cond-> {:field-key :user/given-name
                      :id :first-name
                      :type :text
                      :label "First Name"
                      :placeholder "Enter First Name"
                      :validators [{:validator v/required
                                    :message "Required"}]
                      :transformers [t/trim]
                      :form-field-class (:no-top-padding classes)}
               (some? given-name)
               (assoc :default-value given-name)))

            (rf/input
             (cond-> {:field-key :user/family-name
                      :id :last-name
                      :type :text
                      :label "Last Name"
                      :placeholder "Enter Last Name"
                      :validators [{:validator v/required
                                    :message "Required"}]
                      :transformers [t/trim]}
               (some? family-name)
               (assoc :default-value family-name)))

            (if is-new
              (rf/input
               (cond-> {:field-key :user/email-address
                        :id :email-address
                        :type :email
                        :label "Email"
                        :placeholder "Enter Email"
                        :validators [{:validator v/required
                                      :message "Required"}]
                        :transformers [t/trim t/ensure-lower]}
                 (some? email-address)
                 (assoc :default-value email-address)))
              (rf/input
               {:field-key :user/email-address
                :id :email-address
                :disabled true
                :default-value email-address
                :type :email
                :label "Email"
                :validators [{:validator v/required
                              :message "Required"}]
                :transformers [t/trim]}))

            (when (seq valid-tags)
              (for [{tag-group-uuid :content-provider.tag-group/uuid
                     tag-group-name :content-provider.tag-group/name
                     tag-group-values :content-provider.tag-group/values}
                    valid-tags]

                (when (seq tag-group-values)
                  (let [default-tag-uuid
                        (some #(when (= tag-group-uuid
                                        (:content-provider.tag-group/uuid %))
                                 (:content-provider.tag/uuid %))
                              registration)]

                    [:div {:key tag-group-uuid}
                     (rf/custom-field
                      {:field-key (->> tag-group-uuid (str "tag-group-") keyword)
                       :id (->> tag-group-uuid (str "tag-group-id-") keyword)
                       :label tag-group-name
                       :render select/render
                       :options (into [{:display (str "Select " tag-group-name)
                                        :value select/no-value}]
                                      (map (fn [{tag-uuid :content-provider.tag/uuid
                                                 tag-name :content-provider.tag/name}]
                                             {:display tag-name
                                              :value {:content-provider.tag-group/uuid tag-group-uuid
                                                      :content-provider.tag/uuid tag-uuid}})
                                           (sort-by :content-provider.tag/name tag-group-values)))
                       :default-value (if (and default-tag-uuid
                                               (valid-tag? default-tag-uuid tag-group-values))
                                        {:content-provider.tag-group/uuid tag-group-uuid
                                         :content-provider.tag/uuid default-tag-uuid}
                                        select/no-value)
                       :validators [{:validator #(and (not= % :select-no-value)
                                                      (seq %))
                                     :message "Required"}]
                       :masks []})]))))

            [:div {:class (:cta-container classes)}
             (rf/submit-button
              {:default-text (if is-new "Add User" "Update")})

             [button/secondary-button
              (cond-> {:on-click #(do (.preventDefault %)
                                      (dismiss-fn))
                       :style {:margin-left (gs [:spacing :p20])}}
                (true? @is-submitting)
                (assoc :disabled true))
              "Cancel"]]]]]]))))

(defn render-delete-learner
  [{:keys [event-key dismiss-fn]}]
  (let [is-submitting
        (re-frame/subscribe [:request/is-dispatching event-key])]
    (fn [{:keys [curriculum-uuid curriculum-name learner event-key]}]
      (let [{:user/keys [family-name given-name email-address uuid]
             :curriculum/keys [registration]}
            learner]
       [:div {:class (:form-container classes)}
        [text/title-30 :p (str "Confirm the removal of " given-name " " family-name)]

        [:div {:class (:admin-content-container classes)}
         [text/caption-20 :p (str "This action will remove the following user from curriculum " curriculum-name ".")]]

        [text/title-20 :p "First Name"]
        [text/body-20 :p {:class (:no-top-margin classes)} given-name]

        [text/title-20 :p "Last Name"]
        [text/body-20 :p {:class (:no-top-margin classes)} family-name]

        [text/title-20 :p "Email"]
        [text/body-20 :p {:class (:no-top-margin classes)} email-address]
        
        (for [{tag-group-name :content-provider.tag-group/name
               tag-name :content-provider.tag/name
               tag-uuid :content-provider.tag/uuid}
              registration]
          ^{:key tag-uuid}
          [:<>
           [text/title-20 :p tag-group-name]
           [text/body-20 :p {:class (:no-top-margin classes)} tag-name]])
        
        [:div {:class (:delete-cta-container classes)}
         [button/primary-button
          (cond-> {:on-click #(do (.preventDefault %)
                                  (re-frame/dispatch [event-key
                                                      {:curriculum/uuid curriculum-uuid
                                                       :user/uuid uuid}
                                                      {:response-keys [:curriculum/uuid
                                                                       :user/uuid]
                                                       :on-success dismiss-fn
                                                       :on-success-toast "Learner removed from curriculum."
                                                       :on-failure-toast "Something went wrong removing this learner from the curriculum."}]))
                   :style {:margin-right (gs [:spacing :p20])}}
            (true? @is-submitting)
            (assoc :disabled true))
          "Remove User"]

         [button/secondary-button
          (cond-> {:on-click #(do (.preventDefault %)
                                  (dismiss-fn))}
            (true? @is-submitting)
            (assoc :disabled true))
          "Cancel"]]]))))

(defn render-learner-roster
  [{:keys [collection curriculum-uuid curriculum-name valid-tags edit-event-key delete-event-key]}]
  (let [curriculum-tag-groups (->> collection
                                          (mapv #(:curriculum/registration %))
                                          first)]
   [:table {:class [(:table-container classes)]}
    [:thead {:class [(:table-head classes)]}
     [:tr
      [:th {:style {:text-align :left
                    :vertical-align :middle
                    :width "15%"}}
       [text/title-20 :p
        {:style {:margin-left (str "-" (gs [:spacing :p8]))}}
        "Name"]]
      [:th {:width "20%"}
       [text/title-20 :p "Registered on"]]
      (for [{tag-group-name :content-provider.tag-group/name
             tag-group-uuid :content-provider.tag-group/uuid}
            curriculum-tag-groups]
        [:th {:key tag-group-uuid
              :width "24%"}
         [text/title-20 :p (inflections/singular tag-group-name)]])
      [:th {:width "5%"}]
      [:th {:width "5%"}]]]
    [:tbody
     (for [{:curriculum/keys [registration]
            :curriculum-registration/keys [created-at]
            :user/keys [family-name given-name email-address]
            user-uuid :user/uuid
            :as learner}
           collection]
       [:tr {:key user-uuid
             :class [(:table-body classes)]}
        [:td 
         [text/title-20 :p {:style {:text-align :left}} (str given-name " " family-name)]
         [text/body-20 :p {:style {:text-align :left}} email-address]]
        [text/body-30 :td (ku/date->day-string created-at)]
        (for [{tag-name :content-provider.tag/name
               tag-uuid :content-provider.tag/uuid}
              registration]
          ^{:key tag-uuid} [text/body-20 :td tag-name])
        [:td 
         [button/button-link
          {:style {:text-decoration :underline}
           :on-click
           #(do
              (.preventDefault %)
              (re-frame/dispatch
               [:notifier/create-modal
                {:component render-create-or-update-learner
                 :component-props {:curriculum-uuid curriculum-uuid
                                   :valid-tags valid-tags
                                   :learner learner
                                   :event-key edit-event-key}
                 :dismiss-button-class "notifier-dismiss-button"
                 :hide-dismiss true}]))}
          (str "Edit")]]
        [:td
         [button/icon-button
          {:on-click
           #(do
              (.preventDefault %)
              (re-frame/dispatch
               [:notifier/create-modal
                {:component render-delete-learner
                 :component-props {:curriculum-uuid curriculum-uuid
                                   :curriculum-name curriculum-name
                                   :learner learner
                                   :valid-tags valid-tags
                                   :event-key delete-event-key}
                 :dismiss-button-class "notifier-dismiss-button"
                 :hide-dismiss true}]))}
          :delete]]])]]))

(defn pagination
  [{:keys      [make-new-query-params curriculum-uuid router-ctx]
    {:curriculum.learners.page-info/keys [total-count limit]} :page-info}]
  (let [{:strs [current-page] :or {current-page "0"}} @(re-frame/subscribe [:router/route-query])
        page-size limit
        current-page (js/parseInt current-page)]
    [:div {:style {:display     "grid"
                   :place-items "center"
                   :margin      "10px"}}
     [pagination-controls/render-results {:current-page current-page :page-size page-size :total-items total-count}]
     [pagination-controls/render {:button    button/secondary-button
                                  :on-change (fn [current-page]
                                               (let [new-query-params (make-new-query-params #(merge % {:current-page current-page}))
                                                     new-router-ctx      (assoc router-ctx :query new-query-params)]
                                                 (re-frame/dispatch [:router/nav-to
                                                                     (str (aru/admin-path :curriculum-learners
                                                                                          :curriculum-uuid curriculum-uuid)
                                                                          "?" (map->query new-query-params))])
                                                 (re-frame/dispatch [::<curriculum-learners/fetch-container-data
                                                                     new-router-ctx])))}
      {:current-page current-page :total-pages (j/call js/Math :ceil (/ total-count page-size))}]]))

(defn render
  [{{curriculum-uuid :curriculum-uuid} :params :as context} curriculum]
  (let [#_query
        #_(re-frame/subscribe [:router/route-query])

        search-event-key
        ::<curriculum-learners/fetch-container-data

        export-event-key
        ::<curriculum-learners/fetch-export-data

        create-event-key
        ::>curriculum-pre-reg/create-learner-preregistration

        edit-event-key
        ::>curriculum-pre-reg/update-learner-preregistration

        delete-event-key
        ::>curriculum-pre-reg/delete-learner-preregistration

        is-submitting
        (re-frame/subscribe [:request/is-dispatching search-event-key])]
    (fn [{:keys [resource-status]}]
      (let [<-xforms
            {:page-size js/parseInt
             :current-page js/parseInt
             :sort-order keyword
             :sort-key keyword}

            xforms->
            {:sort-order name
             :sort-key name}

            make-new-query-params
            #(let [current-query-params
                   (aru/xform-query
                    {:query (aru/get-query-params)
                     :xforms <-xforms})

                   new-query-params
                   (aru/xform-query
                    {:query ((partial % current-query-params))
                     :xforms xforms->})]
               (pot/map-keys name new-query-params))

            {page-info :curriculum.learners/page-info

             tag-groups :curriculum/valid-tags}
            @curriculum]

        (if (ku/all-resources-loaded? resource-status)
          [:div {:class (:container classes)}
           [:div {:class (:main-header classes)}
            [:div {:class (:responsive-half-column classes)}
             [text/title-40 :p "Users"]
             [text/body-20 :p "Users who are registered on this curriculum"]]
            [:div {:class (:add-or-export-container classes)}
             [button/primary-button
              {:style {:margin-left (gs [:spacing :p12])}
               :on-click
               #(re-frame/dispatch
                 [export-event-key {:params {:curriculum-uuid curriculum-uuid}}])}
              (str "Export Sign-in URLs")]
             [button/primary-button
              {:style {:margin-left (gs [:spacing :p12])}
               :on-click
               #(do
                  (.preventDefault %)
                  (re-frame/dispatch
                   [:notifier/create-modal
                    {:component render-create-or-update-learner
                     :component-props {:curriculum-uuid curriculum-uuid
                                       :valid-tags tag-groups
                                       :event-key create-event-key}
                     :dismiss-button-class "notifier-dismiss-button"
                     :hide-dismiss true}]))}
              (str "Add New User")]]]
           [:div {:class (:responsive-half-column classes)}
            [rf/form {:id search-event-key
                      :is-submitting is-submitting}
             [:form
              {:rf/form
               {:on-submit
                #(let [{:learner/keys [search]} %
                       new-query-params (make-new-query-params (fn [current-query-params]
                                                                 (cond-> (merge current-query-params {:email-address search
                                                                                                      :current-page 0})
                                                                   (empty? search)
                                                                   (dissoc :email-address))))]
                   (re-frame/dispatch [:router/nav-to
                                       (str (aru/admin-path :curriculum-learners
                                                            :curriculum-uuid curriculum-uuid)
                                            "?" (map->query new-query-params))])
                   (re-frame/dispatch
                    [search-event-key {:params (cond-> {:curriculum-uuid curriculum-uuid}
                                                 (not (str/blank? search))
                                                 (assoc :email-address search))}
                     {:response-keys [:curriculum/uuid]}]))}}
              [:div {:class (:search-container classes)}
               (rf/input
                {:field-key :learner/search
                 :id :learner-search
                 :type :text
                 :placeholder "arnold.davis@yahoo.com, arnold, yahoo"
                 :label "Search by email"
                 :label-class (:search-label classes)
                 :validators [{:validator v/search-count-or-blank
                               :message "Search term must be between 3 and 35 characters."}]
                 :transformers [t/trim t/ensure-lower]})

               (rf/submit-button
                {:default-text "Search"
                 :form-error-message ""
                 :submit-button-class (:search-submit-container classes)})]]]]
           [render-learner-roster
            {:collection (:curriculum/learners @curriculum)
             :curriculum-uuid curriculum-uuid
             :curriculum-name (:curriculum/name @curriculum)
             :edit-event-key edit-event-key
             :delete-event-key delete-event-key
             :valid-tags tag-groups}]
           [pagination
            {:router-ctx context
             :page-info page-info
             :curriculum-uuid       curriculum-uuid
             :make-new-query-params make-new-query-params}]]
          [loading/render
           {:loading-message "Please wait while we fetch your user roster"}])))))
